
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/products",
      function () {
        return require("private-next-pages/brands/products/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/products"])
      });
    }
  